
















































import { defineComponent } from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import JobStatusRenderer from '@/components/Job/JobStatusRenderer.vue';

dayjs.extend(relativeTime);

const BasicJobInfo = defineComponent({
  components: { JobStatusRenderer },
  props: {
    bomName: {},
    jobNo: {},
    customer: {},
    contact: {},
    code: {},
    machineName: {},
    telephone: {},
    quotation: {},
    createdBy: {},
    targetDate: { default: 'NORMAL' },
    createDate: {},
    createdAt: {},
    customerPo: {},
    status: {},
  },
  setup() {
    const toDate = (date: string): string => useFormat.date(date).displayFullThaiDate();

    function compareDate(date: string): number {
      return dayjs().diff(dayjs(date), 'day');
    }

    return {
      toDate,
      compareDate,
    };
  },
});

export default BasicJobInfo;
